// import echarts from "echarts";
export function loadAgeChart(myChart, bfData, name, unit, title = "") {
  myChart.clear();
  if (bfData.length > 0) {
    // 颜色设置
    myChart.setOption({
      // color: ["#00ebf1", "#1851c3", "#cbcbcb", "#ebdc41","#0496e2","#05d7ed"],
      title: {
        text: title,
        textStyle: {
          color: "#ccc",
          fontSize: "12"
        },
        left: "5%",
        top: "5%"
      },
      tooltip: {
        trigger: "item",
        textStyle: {
          fontSize: 16
        },
        formatter: "{a}<br />{b} : {c}" + unit + " ({d}%)"
      },
      series: [
        {
          name: name,
          minShowLabelAngle: 8,
          type: "pie",
          radius: ["20%", "75%"],
          // radius: "50%",
          center: ["50%", "60%"],
          roseType: "radius",
          clockwise: false,
          startAngle: 0,
          hoverAnimation: true,
          data: bfData,

          label: {
            normal: {
              //饼形图显示格式
              // formatter: "{b|{b}}  {per|{d}%} \n\n ",
              formatter: "{b|{b}}  {per|{d}%}",
              // borderWidth: 20,
              // borderRadius: 4,
              padding: [0, 0],
              // formatter: params => {
              //   // return '{b|{b}}  {per|{d}%}\n{cir|●}\n';
              // },
              rich: {
                b: {
                  color: "white",
                  fontSize: 12,
                  lineHeight: 16
                },
                //设置百分比数字颜色
                per: {
                  color: "#00B4FB",
                  fontSize: 14,
                  lineHeight: 16
                }
              }
            }
          },
          labelLine: {
            normal: {
              length: 5,
              length2: 10,
              lineStyle: {
                width: 1
              }
            }
          }
        }
      ]
    });
  } else {
    //空状态
    // myChart.clear();
    const msgOption = {
      title: {
        show: true,
        textStyle: {
          color: "grey",
          fontSize: 20
        },
        text: "暂无数据",
        left: "center",
        top: "center"
      },
      xAxis: {
        show: false
      },
      yAxis: {
        show: false
      },
      series: []
    };
    myChart.setOption(msgOption);
  }
}
